import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { LoadingMessages } from "../../../utils/constants/guest-messages";
import { IPaginationPayload } from "../../../interfaces/shared/IPaginationPayload";
import { tryToFetchGuestsSchedule } from "../../../store/brokers/partner/guests/guestsSlice";
import { useGetGuestDetailsInfoMutation } from "../../../store/reservations/reservationsApi";
import Button from "../../../shared/button";
import Input from "../../../shared/input";
import GuestInfoModal from "../reservations/modals/GuestInfoModal";
import GuestsTable from "./GuestsTable";
import { IGuests } from "../../../interfaces/guests/IGuests";

const Guests2 = () => {
  const navigation = useNavigate();
  const dispatch = useAppDispatch();
  const [rows, setRows] = useState<Array<IGuests>>([]);
  const [loadingData, setLoadingData] = useState<boolean>(true);
  const [showGuestModal, setShowGuestModal] = useState<{
    show: boolean;
    data: any;
    reservationId?: string;
  }>();
  const [search, setSearch] = useState<any>();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchGuest, setSearchGuest] = useState<any>();
  const [loadingText, setLoadingText] = useState(LoadingMessages[0]);
  const [paginationState, setPaginationState] = useState<IPaginationPayload>({
    pageNumber: 1,
    pageSize: 10,
  });
  const paginationData = useAppSelector(
    (state) => state?.guests?.guests2?.page
  );
  const guestsLoading = useAppSelector(
    (state) => state.guests.guestsAreLoading
  );
  const state = useAppSelector((state) => state.guests);

  console.log({state})
  const [getGuestDetailsInfo, { isLoading: isLoadingGuestInfo }] =
    useGetGuestDetailsInfoMutation();

  const onResetPaginationState = () => {
    setPaginationState({
      pageNumber: 1,
      pageSize: paginationState?.pageSize || 10,
    });
    searchParams.set("page", "1");
    searchParams.set("size", `${paginationState?.pageSize || 10}`);
    setSearchParams(searchParams);
  };

  const onCloseModal = () => {
    setShowGuestModal(undefined);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    const paginationStateFormat = paginationState;
    if (
      searchParams?.get("page") &&
      Number(searchParams?.get("page")) !== paginationState?.pageNumber
    ) {
      paginationStateFormat.pageNumber = Number(searchParams?.get("page") || 1);
    }
    if (searchParams?.get("size")) {
      paginationStateFormat.pageSize = Number(searchParams.get("size") || 10);
    }
    if (paginationStateFormat !== paginationState) {
      setPaginationState(paginationStateFormat);
    }
    if (searchParams.get("search")) {
      setSearch(searchParams.get("search") || undefined);
    }
  }, [
    searchParams.get("page"),
    searchParams.get("status"),
    searchParams.get("size"),
    searchParams.get("search"),
    searchParams.get("type"),
  ]);

  const onClickShowGuestInfo = (data: any, reservationId?: string) => {
    setShowGuestModal({
      show: true,
      data: data,
      reservationId: reservationId,
    });
    document.body.style.overflow = "hidden";
  };

  useEffect(() => {
    if (!isLoadingGuestInfo) {
      setLoadingText(LoadingMessages[0]);
      return;
    }

    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % LoadingMessages.length;
      setLoadingText(LoadingMessages[index]);
    }, 5000);

    return () => clearInterval(interval);
  }, [isLoadingGuestInfo]);

  const onChangeSearchGuestValue = (e: any) => {
    setSearchGuest(e);
  };

  const onChangeActiveTab = (tab: any) => {
    setLoadingData(true);
    searchParams.set("type", tab?.value);
    setSearchParams(searchParams);
    onResetPaginationState();
  };

  const onGettingGuestsData = async () => {
    try {
      const fetchData = {
        ...(paginationState || {}),
		data: search,
      };
      await dispatch(tryToFetchGuestsSchedule(fetchData)).unwrap();
    } catch (err) {
      // err
    }
    setLoadingData(false);
  };

  useEffect(() => {
    onGettingGuestsData();
  }, [paginationState]);

  useEffect(() => {
    if (state.guests2) {
      const rows = state?.guests2?.elements;
      setRows(rows);
    }
  }, [state.guests2]);

  const onChangeSearchValue = (e: any) => {
    setSearch(e);
    if (e) searchParams.set("search", e);
    else searchParams.delete("search");
    searchParams.set("page", "1");
    setSearchParams(searchParams);
    onResetPaginationState();
  };

  const onClickSearchProfile = async () => {
    if (searchGuest && searchGuest !== "") {
      try {
        const guestInfoData = {
          name: searchGuest,
        };
        const response: any = await getGuestDetailsInfo(guestInfoData).unwrap();
        onClickShowGuestInfo(response?.data);
        setSearch(undefined);
      } catch (err) {
        // err here
      }
    }
  };

  const onClickDetails = (id: any) => {
    navigation(`/guest-intelligence-2/${id}`);
  };

  const onChangeSelectedStatus = (e: any) => {
    searchParams.set("status", e?.value);
    setSearchParams(searchParams);
    onResetPaginationState();
  };

  return (
    <div>
      <div className="my-3">
        <p className="text-primary-light">Guests</p>
      </div>
      <div className="flex flex-wrap">
        <div className="w-full">
          <div
            className={`flex flex-col md:flex-row md:justify-between md:items-center bg-white mt-3 mb-10 p-1 !rounded`}
          >
            <div>
              <Input
                placeholder={"Search Guest"}
                dataQa={"search"}
                containerStyle="mb-0 pb-0 relative min-w-[400px]"
                inputStyle={`mb-0 border-0 focus:outline-none`}
                icon={"/assets/shared/search.svg"}
                showValue={true}
                inputValue={searchGuest}
                disabled={!!isLoadingGuestInfo}
                inputUniqueName={"search"}
                onChangeInput={onChangeSearchGuestValue}
                hideInputSpace={true}
              />
            </div>
            <div className="flex flex-row justify-center md:justify-end my-3 md:my-0">
              {isLoadingGuestInfo ? (
                <p className="px-2 py-2 text-primary-default">{loadingText}</p>
              ) : (
                <Button
                  label={
                    isLoadingGuestInfo
                      ? "Loading Data..."
                      : "Search Guest Details"
                  }
                  className={`${
                    !isLoadingGuestInfo
                      ? "btn-primary-rounded-less"
                      : "btn-primary-rounded-less-disable cursor-not-allowed"
                  } min-w-auto mr-3`}
                  onClickButton={() => onClickSearchProfile()}
                />
              )}
            </div>
          </div>
          <div className="bg-white !rounded-md p-4">
            <h2 className="text-black text-xl font-semibold mb-2">
              Guest Profiles
            </h2>
            <div className="flex flex-col md:flex-row md:justify-between">
              <div className="px-2 my-4 md:my-0 md:px-0">
                <Input
                  placeholder={"Search guest"}
                  dataQa={"search"}
                  containerStyle="mb-0 pb-0 relative min-w-[340px] "
                  inputStyle={`mb-0 border focus:outline-none !rounded-md`}
                  icon={"/assets/shared/search.svg"}
                  showValue={true}
                  inputValue={search}
                  inputUniqueName={"search"}
                  onChangeInput={onChangeSearchValue}
                  hideInputSpace={true}
                />
              </div>
            </div>
            {showGuestModal?.show && (
              <GuestInfoModal
                openModal={showGuestModal?.show}
                data={showGuestModal?.data || ""}
                reservationId={showGuestModal?.reservationId}
                handleCloseModal={onCloseModal}
              />
            )}
            <GuestsTable
				rows={rows}
				rowsLoading={guestsLoading || loadingData}
				paginationData={paginationData}
				setPaginationState={setPaginationState}
				onClickDetails={onClickDetails}
			/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guests2;
